var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.registerFlag)?[_c('Register',{on:{"submitHandler":_vm.registerHandler,"checkHandle":_vm.checkHandle}})]:[_c('Login',{on:{"submitHandler":_vm.loginHandler,"checkHandle":_vm.checkHandle}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }